module.exports = __webpack_public_path__ + "img/nodis.e95fdee8.png";